import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';

import { InputBlockSettings, InputType } from '@core/models';
import { FormValidators } from '@modules/creator/components/forms/validators/form-validators';

import { Subject } from 'rxjs';

@Injectable()
export class FormService {
  formGroup = this.fb.group({});
  changed = new Subject<{ event: any; formControlName: string }>();
  keyboardEvent = new Subject<any>();

  constructor(private fb: UntypedFormBuilder) {
  }

  addTextControlValidatable(formControlName: string, inputType: InputType, inputSettings?: InputBlockSettings) {
    const emailValidator = inputType === 'email' ? FormValidators.email : Validators.nullValidator;
    let requireValidator = inputType === 'search' ? Validators.nullValidator : Validators.required;
    if (inputSettings !== undefined) {
      requireValidator = inputSettings.required ? Validators.required : Validators.nullValidator;
    }
    this.formGroup.addControl(formControlName,
      new UntypedFormControl('', [requireValidator, emailValidator]));
  }

  addControl(formControlName: string, value: any = '') {
    this.formGroup.addControl(formControlName,
      new UntypedFormControl(value));
  }

  addPasswordControl({formControlName, password}: any) {
    const passwordValidator = password ? FormValidators.password(password) : Validators.nullValidator;
    this.formGroup.addControl(formControlName,
      new UntypedFormControl('', [Validators.required, passwordValidator]));
  }

  setFormErrors(errors: Record<string, string[]>) {
    for (const errorKey in errors) {
      this.formGroup.get(errorKey)?.setErrors({
        serverError: {message: errors[errorKey][0]},
      });
    }
  }

  resetValue(prop: string) {
    this.formGroup.get(prop)?.reset();
  }

  clear(): void {
    this.formGroup.reset();
  }
}
